import { Schema, normalize } from 'normalizr'

export const slotSchema = new Schema('slots')
export const buildingSchema = new Schema('buildings')

slotSchema.define({ building: buildingSchema })

export default function normalizeSlot(slotInfo) {
    const { entities } = normalize(slotInfo, slotSchema)
    const { slots, buildings } = entities
    const slot = slots[slotInfo.id]
    const building = slot.building !== null ? buildings[slot.building] : null
    return { slot, building }
}



// WEBPACK FOOTER //
// ./state/schemas/slots.js